// extracted by mini-css-extract-plugin
export var currencyInput = "_ov-1";
export var currencySymbol = "_ov-0";